/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SortByOptionsTickets.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SortIcon from "@mui/icons-material/Sort";
import SwapVertIcon from "@mui/icons-material/SwapVert";

const SortByOptionsTickets = ({
  selectColumn,
  selectOrder,
  setSelectColumn,
  setSelectOrder,
}) => {
  const sortOptions = [
    { key: "CREATED AT", value: "created_at" },
    { key: "UPDATED AT", value: "updated_at" },
    { key: "INTR ID", value: "intr_id" },
    { key: "TICKET ID", value: "ticket_id" },
    { key: "STATUS", value: "status" },
  ];

  return (
    <Box
      sx={{
        m: "5px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
        >
          <SwapVertIcon sx={{ mr: 1 }} />
          <Typography fontWeight={600} sx={{ fontSize: "0.95rem" }}>
            Sort By
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ py: 0.5 }}>
          <Box>
            <RadioGroup
              value={selectColumn}
              onChange={(e) => setSelectColumn(e.target.value)}
            >
              {sortOptions.map((option) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<Radio size="small" />}
                  label={
                    <Typography sx={{ fontSize: 12 }}>{option.key}</Typography>
                  }
                  sx={{ m: 0, alignItems: "center" }}
                />
              ))}
            </RadioGroup>
            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
              <SortIcon sx={{ mr: 1 }} />
              <Typography fontWeight={600} sx={{ fontSize: "0.95rem" }}>
                Order By
              </Typography>
            </Box>
            <RadioGroup
              row
              value={selectOrder}
              onChange={(e) => setSelectOrder(e.target.value)}
            >
              <FormControlLabel
                value="ASC"
                control={<Radio size="small" />}
                label={<Typography sx={{ fontSize: 12 }}>ASC</Typography>}
                sx={{ m: 0, alignItems: "center" }}
              />
              <FormControlLabel
                value="DESC"
                control={<Radio size="small" />}
                label={<Typography sx={{ fontSize: 12 }}>DSC</Typography>}
                sx={{ m: 0, alignItems: "center" }}
              />
            </RadioGroup>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

SortByOptionsTickets.propTypes = {
  selectColumn: PropTypes.string,
  selectOrder: PropTypes.string,
  setSelectColumn: PropTypes.func,
  setSelectOrder: PropTypes.func,
};

export default SortByOptionsTickets;

